// extracted by mini-css-extract-plugin
export default {"wrapper":"Zy-z","viewport":"_y-z","container":"az-z","slide":"bz-z"};